let containerId = '';
let modalCerrarId = '';

export default class Popup {
    constructor(options = {}) {
        modalCerrarId = options.close || '.modal__cerrar';
        containerId = options.container || '.modal__contenido';

        events();
    }

    html() {
        let $content = document.querySelector(containerId);
        return $content.innerHTML;
    }

    render(html) {
        let $content = document.querySelector(containerId);
        $content.innerHTML = html;
        this.show();
    }

    show() {
        let $body = document.querySelector('body');
        $body.classList.add('modal-activo');
    }

    hide() {
        let $body = document.querySelector('body');
        $body.classList.remove('modal-activo');
    }
};

function events() {
    const $modalCerrar = document.querySelector(modalCerrarId);
    const $body = document.querySelector('body');
    $modalCerrar.addEventListener('click', () => {
        $body.classList.remove('modal-activo');
    });
}


// WEBPACK FOOTER //
// ./Statics/scripts/Core/Popup.js